<ng-container *vsLet="templates$ | async as templates">
  <div class="pt-2 pb-8">
    <vs-card class="overflow-hidden">
      <vs-card-header
        [config]="{
          title: 'Email Templates',
          subtitle: 'Review and manage the default emails sent from organization settings.'
        }"
      >
        <button
          *ngIf="canEdit$ | async"
          vs-button
          slot="end"
          size="sm"
          theme="primary"
          appearance="outline"
          (click)="openCreateDialog()"
        >
          Create New Email Template
        </button>
      </vs-card-header>

      <vs-table [columns]="(columns$ | async) ?? []" [data]="templates"></vs-table>
    </vs-card>

    <ws-settings-edit-email-template-dialog
      #editEmailTemplateDialog
      [emailTemplate]="selectedEmailTemplate"
    ></ws-settings-edit-email-template-dialog>

    <ws-settings-create-email-template-dialog #createEmailTemplateDialog></ws-settings-create-email-template-dialog>

    <ws-settings-email-template-preview-dialog></ws-settings-email-template-preview-dialog>
  </div>
</ng-container>
